import React from 'react';
import PageBase from "../../components/PageBase";

import './Widgets/Widgets.scss';

const Data = props => {
	return (
		<PageBase title="Data">

		</PageBase>
	);
};

export default Data;
